import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { PackagePartItem } from "../../../queries/useSearchPartPackagesByVehicle";
import { KeyValue } from "../../../ui/KeyValue/KeyValue";
import { Placeholder } from "../../../ui/Placeholder";
import { PackageItemList } from "../../Packages/Results/PackageItemList";
import { Details } from "../Common/Details";

type PackageSpecProps = {
  part: PackagePartItem | null;
};

export const PackageSpec: FunctionComponent<PackageSpecProps> = ({ part }) => {
  const { t } = useTranslation();
  return (
    <Details className="text-xs">
      <KeyValue>
        <>{t("searchResults.partNumber")}:</>
        <Placeholder className="w-8" loading={!part}>
          {part?.partDetails.primaryPart.packagePartNumber}
        </Placeholder>
      </KeyValue>
      <PackageItemList primaryPart={part?.partDetails.primaryPart} />
    </Details>
  );
};
